import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { PrimaryPicks_ModuleContextService } from './PrimaryPicks.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class PrimaryPicks_materials_dd_ComponentContextService {
  private readonly moduleContext: PrimaryPicks_ModuleContextService;

  constructor(moduleContext: PrimaryPicks_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'materials_dd',
      type: ComponentType.selector
    }
  }
}